export function numberOrStringAsNumber(
  inputValue: number | string | null | undefined
): number {
  // return inputValue === null ||
  //   inputValue === undefined ||
  //   (typeof inputValue === 'string' && isNaN(parseFloat(inputValue)))
  //   ? 0
  //   : typeof inputValue === 'string'
  //   ? parseFloat(inputValue)
  //   : inputValue
  return Number(inputValue) || 0
}
